
export const prefrences = {
  namespaced: true,

  state: {
    prefrences: {
      InvertedLayout: { value: null, defaultvalue: false, storagekey: "Invert_Layout_Bool" },
      NavMenuWidth: { value: null, defaultvalue: 310, storagekey: "NavMenu_Width" },
      InvertedMobileRouterbtns: { value: null, defaultvalue: false, storagekey: "Invert_Mobile_Routerbtns_Bool" },

      GlobalSearchHistory: { value: null, defaultvalue: [], storagekey: "GlobalSearchHistory" },

      JobApprovalDontShowConfirmation: { value: null, defaultvalue: false, storagekey: "JobApproval_DontShowConfirmation" },
      JobPreviewPaneMode: { value: null, defaultvalue: { text: 'minimal', value: 'minimal' }, storagekey: "JobPreviewPane_Mode" },
      JobListViewOptions: { value: null, defaultvalue: ["Machines", "Appointments"], storagekey: "JobList_ViewOptions" },
      SortJobList: { value: null, defaultvalue: { key: null, desc: false }, storagekey: "SortJobList" },
      FilterJobList: { value: null, defaultvalue: {}, storagekey: "FilterJobList" },
      CustomJobListFilterList: { value: null, defaultvalue: [], storagekey: "CustomJobListFilterList" },
      JobListFilterOrderDepartmentDefault: { value: null, defaultvalue: null, storagekey: "JobListFilterOrderDepartmentDefault" },

      ShowInactiveCustomers: { value: null, defaultvalue: false, storagekey: "CustomerList_ShowInactive" },

      PlannerVersionAllowFallback: { value: null, defaultvalue: false, storagekey: "Planner_Version_Allow_Fallback" },
      PlannerVersion: { value: null, defaultvalue: null, storagekey: "Planner_Version" },
      LimitToWorkHours: { value: null, defaultvalue: true, storagekey: "Limit_To_Work_Hours" },
      PlannerMode: { value: undefined, defaultvalue: 'Scheduler', storagekey: "Planner_Mode" },
      PlannerUserFilter: { value: null, defaultvalue: [], storagekey: "Planner_Filter_User" },
      PlannerUserGroupBy: { value: undefined, defaultvalue: 'type', storagekey: "Planner_User_Group_By" },
      PlannerHiddenUserList: { value: undefined, defaultvalue: null, storagekey: "Planner_Hidden_User_List" },
      PlannerDepartmentList: { value: undefined, defaultvalue: null, storagekey: "Planner_Department_List" },
      PlannerScope: { value: undefined, defaultvalue: 'QDay', storagekey: "Planner_Scope" },
      PlannerMapShow: { value: null, defaultvalue: false, storagekey: "Planner_Map_Show" },
      PlannerMapWidth: { value: null, defaultvalue: 66, storagekey: "Planner_Map_Width" },
      PlannerMapOptions: {
        value: null,
        defaultvalue: {
          mapTypeId: "roadmap",
          disableDefaultUI: true,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
        },
        storagekey: "Planner_Map_Options"
      },
      PlannerMarkerStatusFilter: { value: null, defaultvalue: {}, storagekey: "Planner_Marker_Status_Filter" },
      PlannerJobListShow: { value: null, defaultvalue: true, storagekey: "Planner_JobList_Show" },
      PlannerJobListWidth: { value: null, defaultvalue: 30, storagekey: "Planner_JobList_Width_Percent" },
      PlannerResourceListWidth: { value: null, defaultvalue: 18, storagekey: "Planner_ResourceList_Width" },
      PlannerListShowAsJobs: { value: null, defaultvalue: false, storagekey: "Planner_List_Show_As_Jobs" },
      PlannerListHideCompletedJobs: { value: null, defaultvalue: true, storagekey: "Planner_List_Hide_Completed_Jobs" },
      PlannerListHideAbsence: { value: null, defaultvalue: false, storagekey: "Planner_List_Hide_Abescence" },
      PlannerJobListItemMode: { value: null, defaultvalue: null, storagekey: "Planner_JobList_ItemMode" },
      PlannerJobListDepartmentFilter: { value: null, defaultvalue: null, storagekey: "Planner_JobList_DepartmentFilter" },
      PlannerJobListStatusFilterMultiple: { value: null, defaultvalue: [10], storagekey: "Planner_JobList_StatusFilter_Multiple" },
      PlannerJobListSubStatusFilter: { value: null, defaultvalue: null, storagekey: "Planner_JobList_SubStatusFilter" },

      GroupOrderLinesByMachine: { value: null, defaultvalue: false, storagekey: "Group_OrderLines_ByMachine" },
    },
  },

  mutations: {
    INIT_PREFRENCES(state) {
      for (var prefrencekey in state.prefrences) {
        try {

          var preference = state.prefrences[prefrencekey];
          var stored = JSON.parse(localStorage.getItem(preference.storagekey));
          if (stored != null && stored != undefined) {
            preference.value = stored;
          }
          else {
            preference.value = preference.defaultvalue;
            localStorage.setItem(preference.storagekey, JSON.stringify(preference.value));
          }
        }
        catch (error) {
          console.error("Failed to get setting, resetting key value", prefrencekey, error);
          localStorage.removeItem(preference.storagekey);
        }
      }
    },

    SET_PREFRENCE(state, update) {
      const { key, value } = update;
      var prefrence = state.prefrences[key];
      if (prefrence) {
        prefrence.value = value;
        localStorage.setItem(prefrence.storagekey, JSON.stringify(value));

      }
      else {
        console.error('invalid prefrence', update);
      }
    },
  },

  actions: {
    initiatePrefrences({ commit }) {
      commit("INIT_PREFRENCES");
    },

    set_prefrence({ commit }, update) {
      commit("SET_PREFRENCE", update);
    }
  },

  getters: {
    Prefrence: (state) => (key) => {
      if (state.prefrences[key]) {
        return state.prefrences[key].value;
      }
      else {
        console.error('Falied to get prefrence ' + key);
        return 'UNKNOWN_PREFRENCE'
      }
    },
  },
};
